import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

//validators
import { dropDownValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as util from '../../util/index'

//components


//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';

@Component({
    selector: 'my-equipment-locations',
    templateUrl: './EquipmentLocations.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => EquipmentLocationsComponent) }]
})
export class EquipmentLocationsComponent extends BaseControlGroupComponent {

    request: ent.Request;
    lineItems: ent.EquipmentLocation[] = [];
    lineItemLimit: number = 1000;

    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.request = request;
    }



    constructor(fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {

    }

    onAddLineItemClick(event: any) {
        if (!this.lineItems) { this.lineItems = [] }
        var newLineItem: ent.EquipmentLocation = { EquipmentLocation: "" };

        this.lineItems = [...this.lineItems, newLineItem];
    }

    onDeleteClick(event: any, lineItem: ent.EquipmentLocation) {
        this.lineItems = _.remove(this.lineItems, x => x.EquipmentLocation !== lineItem.EquipmentLocation);
    }

    getEquipmentLocations(): string {
        return this.lineItems.map(function (x) {
            return x.EquipmentLocation;
        }).join("|");
    }

    setEquipmentLocations(equipmentLocations: string) {
        let locs: string[];
        this.lineItems = [];
        if (equipmentLocations) {
            locs = equipmentLocations.split("|");
            for (var loc of locs) {
                var lineItem: ent.EquipmentLocation = { EquipmentLocation: loc };
                this.lineItems = [...this.lineItems, lineItem];
            }
        }

    }

    setLineItemLimit(val: number) {
        this.lineItemLimit = val;
        if (this.disableAdd()) {
            for (let i = 1; i < this.lineItems.length; i++) {
                if (i > this.lineItemLimit) {
                    this.lineItems.splice(i-1);
                }
            }
        }
    }

    disableAdd(): boolean {
        if (this.lineItemLimit && this.lineItems && this.lineItemLimit <= this.lineItems.length) {
            return true;
        }
        return false;
    }
    

}